import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { nav, drawerStyle } from "../InfoBar.styles";
import { DrawerWithEmptyCart } from "@dishopsaas/design-system";
import { useUserDropdown } from "../../../hooks/useUserDropdown";
import { isDarkTheme } from "../../../utils";
type Props = {
  open: boolean;
  onClose: () => void;
  user?: any;
};

export const MobileMenuDrawer: React.FC<Props> = ({ open, onClose }) => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { menuConfig } = useUserDropdown();

  return (
    <DrawerWithEmptyCart
      open={open}
      onClose={onClose}
      anchor="left"
      isEmpty={false}
      width="291px"
      align="flex-start"
      sx={drawerStyle}
      alternativeComponent={
        <Box>
          {menuConfig.map((item) => {
            const isActive = item.path
              ? location.pathname === item.path
              : false;

            return (
              <Box
                key={item.label}
                onClick={() => {
                  if (item.path) {
                    navigate(item.path);
                  }
                  if (item.action) {
                    item.action(onClose);
                  }
                  onClose();
                }}
                sx={{
                  cursor: "pointer",
                  ...nav,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: isActive
                      ? theme.palette.primary.main
                      : isDarkTheme() ? theme.palette.grey[600] : theme.palette.text.primary,
                    transition: "0.2s",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      }
    />
  );
};
